module.exports = __webpack_public_path__ + "5d05f169f8ba77fdd77a2b30d8180bc5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-25.png
// module id = 2500
// module chunks = 0